import { render, staticRenderFns } from "./exceedPeriod.vue?vue&type=template&id=0840b8b9&scoped=true&"
import script from "./exceedPeriod.vue?vue&type=script&lang=js&"
export * from "./exceedPeriod.vue?vue&type=script&lang=js&"
import style0 from "./exceedPeriod.vue?vue&type=style&index=0&id=0840b8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840b8b9",
  null
  
)

export default component.exports